export const CUSTOM_ATTRIBUTE_QUALIFIER = "*";